import React from 'react';
import PolicyPage from './PolicyPage';
import compraEPagamento from './content/compraEPagamento';

const CompraEPagamento = () => (
    <PolicyPage
        titulo="Política Geral de Compra e Pagamento da Empiria"
        versao="Versão atualizada em 22 de julho de 2026"
        blocos={compraEPagamento}
    />
);

export default CompraEPagamento;
